import { useCallback } from 'react'
import { useShoppingCartContext } from '../../../../../providers/ShoppingCartProvider'
import shoppingCartV2API from '../../../../../api'
import nrLogger from '../../../../../../../helpers/nrLogger'
import trackCartProductProtectionUserSelected from '../../../../../../ProductProtectionPlan/gtm/trackCartProductProtectionUserSelected'
import trackCartProductProtectionUserUnSelected from '../../../../../../ProductProtectionPlan/gtm/trackCartProductProtectionUserUnSelected'

const useUpdateProtectionPlan = params => {
  const {
    product,
    plan,
    quantity,
    isOptionSelected,
    setShowOptionLoader,
  } = params

  const {
    getCartId,
    getIdentifier,
    setCart,
    shouldShowLoader,
    setItemProductIdBeingUpdated,
  } = useShoppingCartContext()

  return useCallback(
    async () => {
      shouldShowLoader(true)
      setShowOptionLoader(true)
      setItemProductIdBeingUpdated(product?.productId)

      try {
        const items = [
          {
            product: {
              productId: product?.productId,
              planId: plan.code,
            },
          },
        ]

        let res = {}
        const identifier = getIdentifier()
        const cartId = getCartId()
        const price = (quantity * parseFloat(plan?.price)).toFixed(2)
        const trackData = {
          plan: {
            quantity,
            // price: plan?.price,
            price,
            code: plan?.code,
            type: plan?.type,
            category: plan?.category,
          },
          product: {
            quantity,
            sku: product?.sku,
            part: {
              name: product?.part?.name,
            },
          },
        }
        if (isOptionSelected === false) {
          res = await shoppingCartV2API.productProtection.remove(identifier, cartId, items)
          trackCartProductProtectionUserUnSelected(trackData)
        } else {
          res = await shoppingCartV2API.productProtection.update(identifier, cartId, items)
          trackCartProductProtectionUserSelected(trackData)
        }

        setCart(res)
      } catch (error) {
        nrLogger.error('ShoppingCartV2.useUpdateProtectionPlan.error', error)
      }

      shouldShowLoader(false)
      setShowOptionLoader(false)
    },
    [
      shouldShowLoader,
      setShowOptionLoader,
      product?.productId,
      product?.sku,
      product?.part?.name,
      plan.code,
      plan?.price,
      plan?.type,
      plan?.category,
      getIdentifier,
      getCartId,
      quantity,
      isOptionSelected,
      setCart,
      setItemProductIdBeingUpdated,
    ],
  )
}

export default useUpdateProtectionPlan
